<template>
  <div class="home">
    <img width="150" alt="Vue logo" src="../assets/logo.svg">
    <p class="headText">Authorization</p>
    <div class="authBlock">
      <p>Enter key</p>
      <input v-model="key" type="key" placeholder="Enter key..."/>
      <button class="signButton" @click="signIn">Sign In</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

// @ is an alias to /src
export default {
  name: 'HomeView',
  data() {
    return {
      key: ""
    }
  },
  methods: {
    signIn() {
      axios.post(`${process.env.VUE_APP_SERVERHOST}/api/user`, {
        key: this.key
      })
      .then(res => {
        console.log(res)
        this.$store.commit('setUser', res.data)
        window.location.href = '/'
        console.log(this.$store.state)
      })
      .catch(err => {
        console.log(err)
      })
      // this.$store.commit('setUser', user)
      // console.log(this.$store.state)
    }
  }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.headText {
  font-size: 32px;
}
.authBlock {
  background-color: black;
  border-radius: 35px;
  padding: 2%;
  width: 30%;
  display: flex;
  flex-direction: column;
  gap:10px;
}
.authBlock p {
  /* text-align: left; */
  font-size: 18px;
}
.authBlock input {
  width: 100%;
  font-size: 18px;
  background-color: transparent;
  border-radius: 14px;
  border: 1px solid rgb(186, 186, 186);
  color: white;
  padding:3%;
}
.authBlock:focus {
  border: 1px solid white;
}
.signButton {
  background-color: transparent;
  border: 2px solid white;
  color: white;
  padding: 3%;
  border-radius: 14px;
  font-size: 18px;
  font-family: "Roboto";
  cursor: pointer;
  margin-top: 20px;
  transition: 0.2s all;
}
.signButton:hover {
  background-color: white;
  color: black;
}
</style>